<template src="./Navigation.html"></template>
<style src="./Navigation.scss" lang="scss"></style>

<script>
	import Burger from '@/components/Burger/Burger';

	/**
	 * The Navigation bar in header providing text links, burger menu and partner logo ads.
	 * @vue-data {string} brand The name of the current brand
	 * @vue-data {NodeList} menuReference The reference to the navigation menu
	 * @vue-data {Object[]} fullMenu An array of objects containing all menu items with their reference and their width
	 * @listens Document#colCountChanged
	 */
	export default {
		name: 'HpNavigation',
		data () {
			return {
				brand: '',
				menuReference: '',
				fullMenu: []
			};
		},
		methods: {
			/**
			 * Initializes all data fields with their respective values.
			 */
			initializeMenuPoints () {
				// as we can't do this.$el.querySelector('> ul'); we have to do it this way
				this.menuReference = Array.from(this.$el.children).filter((node) => node.nodeName === 'UL')[0];
				this.menuReference.children.forEach((navElement) => {
					this.fullMenu.push({
						reference: navElement,
						width: navElement.clientWidth
					})
				});

				this.makeMenu();
			},
			/**
			 * Remove all menu items, which will not be fully visible
			 */
			makeMenu () {
				const menuGridGap = parseInt(
					getComputedStyle(this.menuReference)
						.getPropertyValue('--grid-gap')
						.replace('px', '')
						.trim()
					, 10);
				const availableWidth = parseInt(
					getComputedStyle(this.menuReference)
						.getPropertyValue('--ul-max-width')
						.replace('px', '')
						.trim()
					, 10);

				// don't touch the navigation if width is set to auto
				if (isNaN(availableWidth)) {
					return;
				}

				// clear menu to build new
				while (this.menuReference.firstChild) {
					this.menuReference.removeChild(this.menuReference.firstChild);
				}

				let currentUsedWidth = 0;
				this.fullMenu.forEach((item, index) => {
					currentUsedWidth += item.width;
					if (index !== 0) {
						currentUsedWidth += menuGridGap;
					}
					if (currentUsedWidth < availableWidth) {
						this.menuReference.append(item.reference);
					}
				});
			}
		},
		mounted () {
			this.brand = process.env.VUE_APP_BRAND;
			document.addEventListener(
				'colCountChanged',
				(event) => {
					if (event.detail.colCount > 1) {
						this.makeMenu();
					}
				},
				false
			);
			this.initializeMenuPoints();
		},
		components: {
			'hp-burger': Burger
		}
	};
</script>
